export enum QualificationStatus {
  IS_QUALIFIED = 'Is Qualified',
  NOT_QUALIFIED = 'Not Qualified',
  NOT_APPLICABLE = 'Not Applicable',
}
